/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EventService } from '../services/event.service';
import { PropertyTypeService } from '../services/property-type.service'; 

import { Event } from '../models/event';
import { Property } from '../models/property';
import { PropertyType } from '../models/property-type';
import { PropertyTypeParameter } from '../models/property-type-parameter';

declare var $: any;

@Component({
    selector: 'app-event-dialog',
    templateUrl: './event-dialog.component.html'
})
export class EventDialogComponent {
    @Output()
    createOrUpdateEvent = new EventEmitter<boolean>();

    @Input()
    event: Event;
    
    // TODO: These values should be pulled from an API
    eventTypes: string[] = ['Asset', 'Dialog', 'Sewio', 'Tag', 'Timer', 'User', 'Web Switch'];
        
    constructor(
        public propertyTypeService: PropertyTypeService) { this.event = new Event(); }
    
    public show(): void {
        $("#eventDialog").modal("show");
    }
    
    public hide(): void {
         $("#eventDialog").modal("hide");
    }
    
    isNew(): boolean {
        return this.event != null && this.event.id == null;
    }
    
    isEdit(): boolean {
        return this.event != null && this.event.id != null;   
    }
        
    onSave(): void {
        this.createOrUpdateEvent.emit(true);
    }
    
    addProperty(): void {
        if (this.event.properties == null) {
            this.event.properties = []; 
        }

        this.event.properties.push(new Property());
    }

    removeProperty(property: Property): void {
        const index = this.event.properties.indexOf(property);
        
        if (index > -1) {
            this.event.properties.splice(index, 1);
        }
    }
    
    getPropertyTypes(): string[] {
        return Object.keys(PropertyType);
    }
    
    getParametersForPropertyType(propertyType: PropertyType): PropertyTypeParameter[] {
        return this.propertyTypeService.getParametersForPropertyType(propertyType);
    }

}
